import 'whatwg-fetch'
import CartAction from 'actions/Cart'
import PubSub from 'services/PubSub/'
import StorageService from 'services/StorageService/'
import TagManagerService from 'services/TagManager'
import { api } from 'config'
import SalesChannel from 'services/SalesChannel'
import { actionsType } from 'config/constants'

let cache = {
    skuIds: [],
    products: [],
}

let cacheObject = {
    result: {
        skus: {},
    },
    promise: {
        skus: {},
    },
}

const getAll = () => {
    const token = StorageService.getItem('sessionData')

    return fetch(api.shoppingList + `/user/shopping-list`, {
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
        },
    }).then(results => results.json())
        .then(results => {
            if (results && results.status === 401) {
                CartAction.logout(() => {
                    CartAction.logoutRedirect()
                })
            }
            return _orderByDate(results);
        }).catch(() => {
            PubSub.dispatch('error_503')
            return false
        })
}

const get = (list) => {
    const token = StorageService.getItem('sessionData')
    if (typeof window !== 'undefined' && window.__renderData && window.__renderData.shoppingList) {
        return new Promise(resolve => {
            const shoppingList = window.__renderData.shoppingList
            delete window.__renderData.shoppingList
            resolve(shoppingList)
        })
    }
    return fetch(api.shoppingList + `/user/shopping-list/` + list, {
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
        },
    }).then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503')
            return false
        })
}
const getSkusNotFound = (skus) => {
    if (skus === '') {
        return new Promise(resolve => {
            resolve([])
        })
    }
    const token = StorageService.getItem('sessionData')
    if (typeof window !== 'undefined' && window.__renderData && window.__renderData.productsNotAvaliable) {
        cacheObject.promise.skus[skus] = new Promise(resolve => {
            const productsNotAvaliable = window.__renderData.productsNotAvaliable
            delete window.__renderData.productsNotAvaliable
            cacheObject.result.skus[skus] = productsNotAvaliable
            cacheObject.promise.skus[skus] = null
            resolve(productsNotAvaliable)
        })
    }

    if (cacheObject.result.skus && cacheObject.result.skus[skus]) {
        return Promise.resolve(cacheObject.result.skus[skus])
    }

    if (!(cacheObject.result.skus && cacheObject.promise.skus[skus])) {
        cacheObject.promise.skus[skus] = fetch(api.shoppingList + `/user/shopping-list/skus?skuIds=${skus}`, {
            headers: {
                'x-api-key': api.apiKey,
                'token': token,
            },
        }).then(results => {
            cacheObject.promise.skus[skus] = null
            cacheObject.result.skus[skus] = results.json()
            return cacheObject.result.skus[skus]
        })
            .catch(() => {
                cacheObject.promise.skus[skus] = null
                cacheObject.result.skus[skus] = null
                PubSub.dispatch('error_503')
                return false
            })
    }

    return cacheObject.promise.skus[skus]
}

const _clearCache = () => {
    cache.skuIds = [];
    cache.products = [];
}

PubSub.register(actionsType.SET_SALES_CHANNEL, _clearCache);

const productsSkus = (skus, SC = false) => {
    const consults = []
    let skuIds = []

    for (let key in skus) {
        if (cache.skuIds.indexOf(key) === -1) {
            skuIds.push(key)
        }
    }

    if (typeof window !== 'undefined' && window.__renderData && window.__renderData.productsList) {
        return new Promise(resolve => {

            let products = window.__renderData.productsList

            products = products.filter(product => {
                const id = product.items[0].itemId
                if (cache.skuIds.indexOf(id) !== -1) {
                    return false
                }
                cache.skuIds.push(id)
                return true
            }).filter(Boolean)

            cache.products = cache.products.concat(products)

            delete window.__renderData.productsList
            resolve(cache.products.filter((val) => {
                return (Object.keys(skus).indexOf(val.items[0].itemId) != -1)
            }))
        })
    }

    if (skuIds.length) {
        const salesChannel = SalesChannel.getSalesChannel()

        skuIds = _getSeparateIds(skuIds)

        skuIds.map(ids => {
            consults.push(fetch(api.catalog + `/catalog_system/pub/products/search/?_from=0&_to=49${('&fq=skuId%3A' + ids.join('&fq=skuId%3A'))}&sc=${SC ? SC : salesChannel}`, {
                headers: {
                    'x-api-key': api.apiKey,
                },
            }).then(results => results.json())
                .catch(() => {
                    PubSub.dispatch('error_503')
                    return false
                }))
        })

        return Promise.all(consults).then(results => {
            let products = []
            results.map(result => {
                products = products.concat(result)
                products = products.filter(product => {
                    if (!(product && product.items && product.items[0])) return false
                    const id = product.items[0].itemId
                    if (cache.skuIds.indexOf(id) !== -1) {
                        return false
                    }
                    cache.skuIds.push(id)
                    return true
                }).filter(Boolean)
                cache.products = cache.products.concat(products)
            })

            return cache.products.filter((val) => {
                return (Object.keys(skus).indexOf(val.items[0].itemId) !== -1)
            })
        })

    } else {
        return new Promise((resolve) => {
            let response = []
            Object.keys(skus).map((key) => {
                response = response.concat(cache.products.filter((val) =>
                    parseInt(val.items[0].itemId) === parseInt(key),
                ))
                return key
            })

            resolve(response)
        })
    }
}

const _getSeparateIds = (ids) => {
    const limit = 10
    const separatorIds = []
    let indexSeparator = 0
    let indexId = 0

    ids.map((id) => {
        if (indexId >= limit) {
            indexSeparator++
            indexId = 0
        }
        if (!separatorIds[indexSeparator]) {
            separatorIds[indexSeparator] = []
        }
        separatorIds[indexSeparator].push(id)
        indexId++
    })
    return separatorIds
}

const createEmptyList = (name) => {
    TagManagerService.createList('Crear', name)
    return createList(name, {})
}

const deleteList = (listID) => {

    const token = StorageService.getItem('sessionData')

    return fetch(api.shoppingList + `/user/shopping-list/` + listID, {
        method: 'DELETE',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
        },
    }).then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503')
            return false
        })
}

const updateList = (list) => {

    const token = StorageService.getItem('sessionData')

    return fetch(api.shoppingList + `/user/shopping-list/` + list.id, {
        method: 'PUT',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            'name': list.name,
            'skus': JSON.stringify(list.skus),
            'type': 'client',
        }),
    })
}

const createList = (orderName, skus) => {
    const token = StorageService.getItem('sessionData')

    return fetch(api.shoppingList + `/user/shopping-list`, {
        method: 'POST',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            'name': orderName,
            'skus': JSON.stringify(skus),
            'type': 'client',
        }),
    }).then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503')
            return false
        })
}


const addProdsToCart = (list) => {
    const data = list.skus
    let listProducts = []
    let productsFormatted = []

    for (let key in data) {

        let index = list.products.findIndex(val => val.items[0].itemId === key)
        if (index !== -1) {
            productsFormatted = { 'id': key, 'quantity': list.products[index].quantity }
            listProducts.push(productsFormatted)
        }
    }

    let productsItems = []

    let prodsAvailables = list.products ? list.products.filter(product => product.items && product.items[0].prices && product.items[0].prices.regular) : []
    const QtyProdAvailable = prodsAvailables.length

    prodsAvailables.map((product, i) => {
        product.pos = i
        productsItems.push(product)

        if (i > 0 && ((i + 1) % 20) === 0) {
            TagManagerService.productClickList(productsItems, list.name)
            TagManagerService.addProductListToCart(productsItems)
            productsItems = []
        }
        if (i === (QtyProdAvailable - 1)) {
            TagManagerService.productClickList(productsItems, list.name)
            TagManagerService.addProductListToCart(productsItems)
        }
        return product
    })

    const addItems = CartAction.addItems(listProducts)
    PubSub.dispatch('cart_productAdd', { promise: addItems })
    return addItems
}

const creationListDate = (order) => {
    let indexDate = order.creationDate.indexOf('T') !=-1 ? order.creationDate.indexOf('T') : order.creationDate.indexOf(' ');
    let orderName = 'Compra ' + order.creationDate.substring(0, indexDate).replace(/-/g, '/').split('/').reverse().join('/');
    const objSkus = {};

    order.items.map(item => {
        objSkus[item.id] = { quantity: item.quantity };
    });
    return createList(orderName, objSkus).then((res) => {
        let idList = res.DocumentId;
        window.location.href = `/lista-de-compra?l=${idList}`;
        return res;
    });


}

const _orderByDate = (list) => {
    if (!list || list.status) {
        return []
    }

    return list.sort((a, b) => {
        if (a.createdIn > b.createdIn) {
            return -1
        } else {
            return 1
        }
    }).filter(item => item.id)
}

const ListService = {
    getAll,
    get,
    getSkusNotFound,
    productsSkus,
    _getSeparateIds,
    createEmptyList,
    deleteList,
    updateList,
    createList,
    addProdsToCart,
    creationListDate

}

export default ListService
